import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';
import { getToken } from '@/utils/auth';
import Home from '@/views/Home.vue';

Vue.use(Router);

/**
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    withoutToken: true           if set true, visit this page can without token
  }
 */

export const constantRoutes = [
  {
    path: '/redirect',
    component: Home,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('./views/Redirect.vue'),
      },
    ],
  }, {
    path: '/login',
    name: 'login',
    component: Login,
  }, {
    path: '/App',
    name: 'App',
    component: () => import('./views/income-app/App.vue'),
    meta: { title: '手机首页' },
  }, {
    path: '/AppList',
    name: 'AppList',
    component: () => import('./views/income-app/AppList.vue'),
    meta: { title: '历史记录' },
  }, {
    path: '/AppIncome',
    name: 'AppIncome',
    component: () => import('./views/income-app/AppIncome.vue'),
    meta: { title: '库存管理' },
  }, {
    path: '/AppDeliver',
    name: 'AppDeliver',
    component: () => import('./views/income-app/AppDeliver.vue'),
    meta: { title: '库存管理' },
  }, {
    path: '/AppTpProd',
    name: 'AppTpProd',
    component: () => import('./views/income-app/AppTpProd.vue'),
    meta: { title: '库存管理' },
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    redirect: '/homepage',
    meta: { title: '首页' },
    children: [
      {
        path: '/homepage',
        component: () => import('./views/home-page/index.vue'),
        name: 'HomePage',
        meta: { title: '首页', affix: true },
      },
    ],
  },
  {
    path: '/incoming-order',
    name: 'IncomingOrder',
    component: Home,
    redirect: '/incoming-order/list',
    children: [
      {
        path: 'list',
        component: () => import('./views/incoming-order/list.vue'),
        name: 'IncomingOrderList',
        meta: { title: '订单记录' },
      },
      {
        path: 'edit/:orderNo([\\w\\W]+)',
        component: () => import('./views/incoming-order/edit.vue'),
        name: 'IncomingOrderEdit',
        meta: { title: '订单详情', noCache: true },
      },
      {
        path: 'create',
        component: () => import('./views/incoming-order/create.vue'),
        name: 'IncomingOrderCreate',
        meta: { title: '新建订单' },
      },
    ],
  }, {
    path: '/product-manage',
    component: Home,
    redirect: '/product-manage/list',
    children: [
      {
        path: 'list',
        component: () => import('./views/product-manage/list.vue'),
        name: 'Product-Manage',
        meta: { title: '产品列表' },
      },
    ],
  }, {
    path: '/income-storage',
    component: Home,
    redirect: '/income-storage/list',
    children: [
      {
        path: 'list',
        component: () => import('./views/income-storage/list.vue'),
        name: 'IncomeStorageList',
        meta: { title: '来料记录' },
      },
      {
        path: 'edit/:id(\\d+)',
        component: () => import('./views/income-storage/edit.vue'),
        name: 'IncomeStorageEdit',
        meta: { title: '记录详情', noCache: true },
      },
    ],
  }, {
    path: '/product-storage',
    component: Home,
    redirect: '/product-storage/list',
    children: [
      {
        path: 'list',
        component: () => import('./views/product-storage/list.vue'),
        name: 'ProductStorageList',
        meta: { title: '成品' },
      },
      {
        path: 'edit/:id(\\d+)',
        component: () => import('./views/product-storage/detail.vue'),
        name: 'ProductStorageDetail',
        meta: { title: '成品详情', noCache: true },
      },
    ],
  }, {
    path: '/delivery-order',
    component: Home,
    redirect: '/delivery-order/index',
    children: [
      {
        path: 'index',
        component: () => import('./views/deliver-goods/delivery-order/index.vue'),
        name: 'DeliveryOrder',
        meta: { title: '发货建单' },
      },
    ],
  }, {
    path: '/delivery-operation',
    component: Home,
    redirect: '/delivery-operation/index',
    children: [
      {
        path: 'index',
        component: () => import('./views/deliver-goods/delivery-operation/index.vue'),
        name: 'DeliveryOperationIndex',
        meta: { title: '发货操作' },
      },
    ],
  }, {
    path: '/scan-return-ticket',
    component: Home,
    redirect: '/scan-return-ticket/index',
    children: [
      {
        path: 'index',
        component: () => import('./views/deliver-goods/scan-return-ticket/index.vue'),
        name: 'ScanReturnTicketIndex',
        meta: { title: '扫描回签单' },
      },
    ],
  }, {
    path: '/deliver-history',
    component: Home,
    redirect: '/deliver-history/index',
    children: [
      {
        path: 'index',
        component: () => import('./views/deliver-goods/deliver-history/list.vue'),
        name: 'DeliveryHistory',
        meta: { title: '历史发货' },
      },
    ],
  }, {
    path: '/invoice/:productOrderNo(\\w+)',
    component: () => import('./views/deliver-goods/delivery-operation/invoice.vue'),
    name: 'Invoice',
  }, {
    path: '/deliver-order-detail',
    component: Home,
    redirect: '/deliver-order-detail/edit',
    children: [
      {
        path: 'edit/:productOrderNo(\\w+)',
        component: () => import('./views/deliver-goods/deliver-order-detail/index.vue'),
        name: 'DeliverOrderDetail',
        meta: { title: '发货单详情', noCache: true },
      },
    ],
  }, {
    path: '/tpProd-order',
    component: Home,
    redirect: '/tpProd-order/index',
    children: [
      {
        path: 'index',
        component: () => import('./views/tpProdOrder-manage/tpProd-order/index.vue'),
        name: 'TpProdOrder',
        meta: { title: '代发建单' },
      },
    ],
  }, {
    path: '/tpProd-operation',
    component: Home,
    redirect: '/tpProd-operation/index',
    children: [
      {
        path: 'index',
        component: () => import('./views/tpProdOrder-manage/tpProd-operation/index.vue'),
        name: 'TpProdOperationIndex',
        meta: { title: '代发操作' },
      },
    ],
  }, {
    path: '/tpProd-scan-return-ticket',
    component: Home,
    redirect: '/tpProd-scan-return-ticket/index',
    children: [
      {
        path: 'index',
        component: () => import('./views/tpProdOrder-manage/tpProd-scan-return-ticket/index.vue'),
        name: 'TpProdScanReturnTicketIndex',
        meta: { title: '代发扫描回签单' },
      },
    ],
  }, {
    path: '/tpProd-history',
    component: Home,
    redirect: '/tpProd-history/index',
    children: [
      {
        path: 'index',
        component: () => import('./views/tpProdOrder-manage/tpProd-history/list.vue'),
        name: 'TpProdHistory',
        meta: { title: '代发历史' },
      },
    ],
  }, {
    path: '/tpinvoice/:productOrderNo(\\w+)',
    component: () => import('./views/tpProdOrder-manage/tpProd-operation/tpinvoice.vue'),
    name: 'tpInvoice',
  }, {
    path: '/tpProd-order-detail',
    component: Home,
    redirect: '/tpProd-order-detail/edit',
    children: [
      {
        path: 'edit/:productOrderNo(\\w+)',
        component: () => import('./views/tpProdOrder-manage/tpProd-order-detail/index.vue'),
        name: 'TpProdOrderDetail',
        meta: { title: '代发详情', noCache: true },
      },
    ],
  }, {
    path: '/test-progress',
    component: Home,
    redirect: '/test-progress/list',
    children: [
      {
        path: 'list',
        component: () => import('./views/test-progress/list.vue'),
        name: 'TestProgressList',
        meta: { title: '进度列表' },
      },
    ],
  }, {
    path: '/factory-label-template',
    component: Home,
    redirect: '/factory-label-template/list',
    children: [
      {
        path: 'list',
        component: () => import('./views/factory-label-template/list.vue'),
        name: 'FactoryLabelTemplate',
        meta: { title: '发货标签模板' },
      },
    ],
  }, {
    path: '/factory-label-history',
    component: Home,
    redirect: '/factory-label-history/list',
    children: [
      {
        path: 'list',
        component: () => import('./views/factory-label-history/list.vue'),
        name: 'FactoryLabelHistory',
        meta: { title: '历史发货标签' },
      },
    ],
  }, {
    path: '/label-manage',
    name: 'label-manage',
    component: () => import('./views/label-manage/index.vue'),
  }, {
    path: '/factory-label-print',
    name: 'factory-label-print',
    component: () => import('./views/factory-label-print/index.vue'),
  }, {
    path: '/404',
    component: () => import('./views/error-page/404'),
    name: 'Page404',
    meta: { title: '404', noCache: true },
  }, {
    path: '/customers-page',
    component: Home,
    redirect: '/customers-page/list',
    children: [
      {
        path: 'list',
        component: () => import('./views/customers-page/list.vue'),
        name: 'Customers',
        meta: { title: '客户列表' },
      },
      {
        path: 'edit/:id(\\d+)',
        component: () => import('./views/customers-page/detail.vue'),
        name: 'CustomerDetail',
        meta: { title: '客户详情', noCache: true },
      },
    ],
  }, {
    path: '/asset-management',
    component: Home,
    redirect: '/asset-management/device',
    children: [
      {
        path: 'device',
        component: () => import('./views/asset-management/device/list.vue'),
        name: 'DeviceManagement',
        meta: { title: '设备管理' },
      },
      {
        path: '/device/edit/:deviceId([\\w\\W]+)',
        component: () => import('./views/asset-management/device/edit.vue'),
        name: 'DeviceEdit',
        meta: { title: '修改设备', noCache: true },
      },
      {
        path: '/device/create',
        component: () => import('./views/asset-management/device/create.vue'),
        name: 'DeviceCreate',
        meta: { title: '新建设备' },
      },
      {
        path: 'subDevice',
        component: () => import('./views/asset-management/subDevice/list.vue'),
        name: 'SubDeviceManagement',
        meta: { title: '组件管理' },
      },
      {
        path: '/subDevice/edit/:subDeviceId([\\w\\W]+)',
        component: () => import('./views/asset-management/subDevice/edit.vue'),
        name: 'SubDeviceEdit',
        meta: { title: '修改组件', noCache: true },
      },
      {
        path: '/subDevice/create',
        component: () => import('./views/asset-management/subDevice/create.vue'),
        name: 'SubDeviceCreate',
        meta: { title: '新建组件' },
      },
      {
        path: 'deviceDelivery',
        component: () => import('./views/asset-management/deviceDelivery/list.vue'),
        name: 'DeviceDeliveryList',
        meta: { title: '设备发货' },
      },
      {
        path: '/deviceDelivery/create',
        component: () => import('./views/asset-management/deviceDelivery/create-delivery/create.vue'),
        name: 'DeviceDeliveryCreate',
        meta: { title: '新建设备发货' },
      },
      {
        path: '/deviceDelivery/edit/:deliveryId([\\w\\W]+)',
        component: () => import('./views/asset-management/deviceDelivery/edit.vue'),
        name: 'DeviceDeliveryEdit',
        meta: { title: '修改设备发货' },
      },
    ],
  },
  {
    path: '/delivery-list/:deliveryId(\\w+)',
    component: () => import('./views/asset-management/deviceDelivery/delivery-list.vue'),
    name: 'DeliveryList',
  },
  {
    path: '/device-info',
    component: () => import('./views/asset-management/device-info/index.vue'),
    name: 'DeviceInfo',
    meta: { title: '修改设备发货', withoutToken: true },
  },
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404' },
];

const router = new Router({
  routes: constantRoutes,
});

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.withoutToken) {
    next();
    return;
  }
  const token = getToken();
  if (token) {
    if (to.path === '/login') {
      next({ path: '/' });
    } else {
      next();
    }
  } else if (to.path === '/login') {
    next();
  } else {
    next(`/login?redirect=${to.path}`);
  }
});

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default router;
